// extracted by mini-css-extract-plugin
export var EventTheme1 = "Main-module--EventTheme1--845bc";
export var EventTheme2 = "Main-module--EventTheme2--343c0";
export var EventTheme3 = "Main-module--EventTheme3--48959";
export var Main = "Main-module--Main--ae446";
export var rhombi = "Main-module--rhombi--095fb";
export var rhombusFour = "Main-module--rhombusFour--7c6ef";
export var rhombusOne = "Main-module--rhombusOne--87e35";
export var rhombusThree = "Main-module--rhombusThree--a949a";
export var rhombusTwo = "Main-module--rhombusTwo--51cd0";